(function () {
  function hideCheckout() {
    if (!document.querySelector('.samitaWS-paylater-button')) return;

    // Cart-Buttons (Drawer + /cart-Seite)
    document.querySelectorAll(
      '.samitaWS-clone-checkout-button, ' +
      '.samitaWS-original-checkout-button, ' +
      'button[name="checkout"]'
    ).forEach(function (btn) { btn.style.display = 'none'; });

    // Cart-Drawer Form-Wrapper
    document.querySelectorAll('.drawer__footer-buttons').forEach(function (form) {
      form.style.display = 'none';
    });
    // Cart-Page Buttons-Wrapper
    document.querySelectorAll('button[name="checkout"][form="cart"]').forEach(function (btn) {
      var wrapper = btn.closest('.grid.gap-3');
      if (wrapper) wrapper.style.display = 'none';
    });

    // Dynamic Checkout Buttons (Shop Pay, Apple Pay etc.) auf der Produktseite
    document.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach(function (el) {
      el.style.display = 'none';
    });
  }
  setInterval(hideCheckout, 50);
})();